import notifierSlice from "./notifierSlice";

export default notifierSlice.reducer;